
import Vue from 'vue'
import {
  VCard,
  VDivider,
  VIcon,
  VList,
  VListItem,
  VListItemAction,
  VListItemContent,
  VListItemGroup,
  VListItemTitle,
  VSubheader,
} from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcListBox',
  components: {
    VCard,
    VList,
    VSubheader,
    VListItemGroup,
    VListItem,
    VListItemContent,
    VListItemTitle,
    VListItemAction,
    VIcon,
    VDivider,
  },
  props: {
    subHeader: {
      type: String,
      default: '',
    },
    itemList: {
      type: Array as () => Array<string>,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: [],
    }
  },
  computed: {
    sortedItems() {
      const sortedItems = this.itemList
      return sortedItems.sort((a, b) => a.localeCompare(b))
    },
  },
})
